"use strict";
exports.__esModule = true;
exports.SymbolBuilder = exports.Symbol = exports.SymbolCollectionBuilder = exports.SymbolCollection = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var Design_1 = require("./Design");
var SymbolCollection = /** @class */ (function () {
    function SymbolCollection() {
    }
    SymbolCollection.isPublishable = function (symbolCollection, associatedSymbols) {
        if (symbolCollection.symbols.length === 0)
            return false;
        for (var _i = 0, associatedSymbols_1 = associatedSymbols; _i < associatedSymbols_1.length; _i++) {
            var symbol = associatedSymbols_1[_i];
            if (!Symbol.isPublishable(symbol))
                return false;
        }
        return true;
    };
    return SymbolCollection;
}());
exports.SymbolCollection = SymbolCollection;
var SymbolCollectionBuilder = /** @class */ (function () {
    function SymbolCollectionBuilder(symbolCollection) {
        this.symbolCollection = symbolCollection;
    }
    SymbolCollectionBuilder.initialiseWithSymbolCollection = function (symbolCollection) {
        return new SymbolCollectionBuilder(symbolCollection);
    };
    SymbolCollectionBuilder.initialise = function (title, description) {
        return SymbolCollectionBuilder.initialiseWithSymbolCollection({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            title: title,
            description: description,
            symbols: []
        });
    };
    SymbolCollectionBuilder.prototype.hasSymbol = function (symbolId) {
        return this.symbolCollection.symbols.includes(symbolId);
    };
    SymbolCollectionBuilder.prototype.addSymbol = function (symbolId) {
        this.symbolCollection.symbols = Array.from(new Set(this.symbolCollection.symbols).add(symbolId));
        return this;
    };
    SymbolCollectionBuilder.prototype.removeSymbol = function (symbolId) {
        var theSet = new Set(this.symbolCollection.symbols);
        theSet["delete"](symbolId);
        this.symbolCollection.symbols = Array.from(theSet);
        return this;
    };
    SymbolCollectionBuilder.prototype.withId = function (id) {
        this.symbolCollection.id = id;
        return this;
    };
    SymbolCollectionBuilder.prototype.getId = function () {
        return this.symbolCollection.id;
    };
    SymbolCollectionBuilder.prototype.build = function () {
        return this.symbolCollection;
    };
    SymbolCollectionBuilder.prototype.buildUpdate = function () {
        return {
            title: this.symbolCollection.title,
            description: this.symbolCollection.description,
            symbols: this.symbolCollection.symbols
        };
    };
    return SymbolCollectionBuilder;
}());
exports.SymbolCollectionBuilder = SymbolCollectionBuilder;
var Symbol = /** @class */ (function () {
    function Symbol() {
    }
    Symbol.isPublishable = function (symbol) {
        return Symbol.hasMediaValid(symbol) && Symbol.hasBoundingShapeValid(symbol);
    };
    Symbol.hasMediaValid = function (symbol) {
        return core_common_domain_1.Media.isValidWithContentType(symbol.media, core_common_domain_1.MimeType.SVG);
    };
    Symbol.hasBoundingShapeValid = function (symbol) {
        return Design_1.Shape.isValidDefined(symbol.boundingShape);
    };
    return Symbol;
}());
exports.Symbol = Symbol;
var SymbolBuilder = /** @class */ (function () {
    function SymbolBuilder(symbol) {
        this.symbol = symbol;
    }
    SymbolBuilder.initialiseWithSymbol = function (symbol) {
        return new SymbolBuilder(symbol);
    };
    SymbolBuilder.initialise = function (title, description) {
        return SymbolBuilder.initialiseWithSymbol({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            title: title,
            description: description,
            media: core_common_domain_1.Media.UNDEFINED,
            boundingShape: Design_1.ShapeBuilder.initialise().build()
        });
    };
    SymbolBuilder.prototype.withId = function (id) {
        this.symbol.id = id;
        return this;
    };
    SymbolBuilder.prototype.getId = function () {
        return this.symbol.id;
    };
    SymbolBuilder.prototype.withMedia = function (newMedia) {
        this.symbol.media = newMedia;
        return this;
    };
    SymbolBuilder.prototype.withBoundingShape = function (newBoundingShape) {
        this.symbol.boundingShape = newBoundingShape;
        return this;
    };
    SymbolBuilder.prototype.build = function () {
        return this.symbol;
    };
    SymbolBuilder.prototype.buildUpdate = function () {
        return {
            boundingShape: this.symbol.boundingShape,
            title: this.symbol.title,
            description: this.symbol.description,
            media: this.symbol.media
        };
    };
    return SymbolBuilder;
}());
exports.SymbolBuilder = SymbolBuilder;
